// extracted by mini-css-extract-plugin
module.exports = {"hamburgerIcon":"styles_hamburgerIcon__4oTM5","line":"styles_line__jBI6O","open":"styles_open__1qle6"};